import {TextAlignment} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import Div from './Div.styled';
import LottieButtonNextCTA from './LottieButtonNextCTA';
import TypographyHeading from './Typography/TypographyHeading';
import TypographyBody from './Typography/TypographyBody';

export interface IQuestionContentWrapperProps {
  title?: string;
  handleClick?: () => void;
  disabled?: boolean;
  maxWidthContent?: number | string;
  children: React.ReactNode;
  maxWidthTitle?: number | string;
  hiddenButton?: boolean;
  skipQuestion?: () => void;
  step?: number;
  label?: React.ReactNode;
}

export default function QuestionContentWrapper({
  step,
  title,
  handleClick,
  children,
  disabled,
  maxWidthContent = '400px',
  maxWidthTitle = '800px',
  hiddenButton,
  skipQuestion,
  label,
}: IQuestionContentWrapperProps) {
  const {isDesktop} = useMediaQuery();
  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);
  return (
    <Div className="question-container no-scroll">
      <TypographyHeading
        style={{maxWidth: `${maxWidthTitle}`}}
        textAlign={TextAlignment.center}
        size="large"
      >
        {title}
      </TypographyHeading>
      {label}
      <Div
        customStyles={{
          marginTop: isDesktop ? '80px' : '50px',
          maxWidth: `${maxWidthContent}`,
          width: '100%',
        }}
      >
        <Div className="question-content no-scroll">{children}</Div>
        {skipQuestion && step != 5 && (
          <TypographyBody
            style={{
              marginTop: '40px',
              fontSize: 16,
              fontWeight: 400,
              textAlign: 'center',
            }}
            color="white"
          >
            {' '}
            Don&apos;t have a car?{' '}
            <span
              role="button"
              tabIndex={0}
              style={{
                textDecorationSkipInk: 'none',
                cursor: 'pointer',
              }}
              onClick={skipQuestion}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  skipQuestion();
                }
              }}
              className="button-text"
            >
              Please continue here
            </span>
          </TypographyBody>
        )}
        {!hiddenButton && (
          <Div
            customStyles={{
              textAlign: 'center',
              width: '100%',
            }}
          >
            <LottieButtonNextCTA isDisabled={disabled} onClick={handleClick} />
          </Div>
        )}
      </Div>
    </Div>
  );
}
